import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";
import { TableBodyBase, type TableBodyBaseProps } from "@core/ui";

export type Props = Omit<TableBodyBaseProps, "data-testid">;

/**
 * Styled table body section wrapping TableBodyBase.
 */
export const TableBody = forwardRef<HTMLTableSectionElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <TableBodyBase
        ref={ref}
        className={twMerge("[&>tr:last-child]:border-0", className)}
        data-testid="table-body"
        {...props}
      />
    );
  }
);

TableBody.displayName = "TableBody";

export default TableBody;

